import { useEffect, useMemo, useRef, useState } from 'react';
import { useCookies } from 'next-client-cookies';
import { useTranslations } from 'use-intl';
import { FilterIconLightMobile } from 'components/icons';
import { getLocalizationInfo } from 'project.config';
import { useCart } from 'frontastic';
import { useProductList } from '../../context';
import styles from '../../styles/index.module.css';
import { SortConfiguration } from '../../types';
import { RetailPickUp } from '../desktop-facets/Retailpickup';
import SortFacet from '../facets/sort';

export interface MobileFacetsProps {
  sortConfiguration?: SortConfiguration[];
  openFacets?: boolean;
  setOpenFacets?: any;
  pickUpToday?: string;
  filterLabel?: string;
  sortbyLabel?: string;
}
const MobileFacets: React.FC<MobileFacetsProps> = ({ sortConfiguration, setOpenFacets, pickUpToday, filterLabel }) => {
  const translate = useTranslations();
  const cookies = useCookies();
  const locale = cookies.get('locale') as string;
  const { countryCode } = getLocalizationInfo(locale);
  const { isContainsP2RItems } = useProductList();

  const [isOpen, setIsOpen] = useState(false);
  const { shippingMethodsData } = useCart();

  const showP2R = (shippingMethodsData.data ?? []).some((method) =>
    method.shippingMethodKey?.toLowerCase().startsWith('p2r'),
  );

  const sortFacet = useMemo(
    () => (
      <div className="sortDropdown min-w-225">
        <SortFacet sortConfiguration={sortConfiguration} />
      </div>
    ),
    [translate],
  );

  const drawerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!isOpen || !drawerRef.current) return;

    const focusable = drawerRef.current.querySelectorAll<HTMLElement>(
      'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])',
    );

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setIsOpen(false);
      }

      if (e.key !== 'Tab') return;

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      }
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    setTimeout(() => first?.focus(), 0);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen]);

  return (
    <div
      className="mx-24 flex flex-wrap items-center justify-between gap-x-4 gap-y-16 border-y-2 border-[#EBEBEB] py-16"
      data-ffid="ctr-filter-sort-mobile"
    >
      <div data-ffid="ctr-filter-mobile">
        <button
          data-ffid="btn-filters-mobile"
          onClick={() => {
            setOpenFacets(true);
          }}
          className={`mr-12 flex rounded-[34px] px-14 py-12 text-14 text-white ${styles.facet_button}`}
          type="button"
        >
          <FilterIconLightMobile className="pt-4" /> {filterLabel}
        </button>
      </div>
      {sortFacet}
      {countryCode === 'US' && isContainsP2RItems && showP2R && (
        <div data-ffid="ctr-retail-pickup">
          <RetailPickUp pickUpToday={pickUpToday} />
        </div>
      )}
    </div>
  );
};

export default MobileFacets;
